import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../common/src/stores/CollectionStore";
import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";

@Module()
export class ConferenceCollectionStore extends CollectionStore<ConferenceListItem> {
    sort: keyof ConferenceListItem = "startDate";
}
